module.exports = __webpack_public_path__ + "img/video-player/up-51ae5aeb2e506945cb1635fc4f19ef86.png";